<template>
    <div class="pricing-plans" v-if="validPlans">
        <div class="pricing-plans__header text-center">
            <h2 class="m-0" v-if="!hasSlot('header')">{{ title }}</h2>
            <slot name="header" />
        </div>
        <div class="pricing-plans__list-plan">
            <div :class="['plan-wrap',{'plan-popular': value.is_hightlighted}]" v-for="(value, name) in sortedPlans" :key="name">
                <div v-if="value.is_hightlighted" class="is-highlighted">{{most_popular_text}}</div>
                <div :class="['plan', value.name]">
                    <h3 class="m-b-0 plan-name">{{value.title}}</h3>
                    <div class="plan-price">
                        <span class="plan-price__icon">$</span>
                        <span class="plan-price__money">{{ value.price }}</span>
                        <span :class="['plan-price__month', {'visible': value.is_hightlighted}]"> /mo</span>
                    </div>
                    <slot :name="`submit_button__${name}`" />
                    <form method="post" action="" v-if="!hasSlot(`submit_button__${name}`)">
                        <input type="hidden" name="_token" value="">
                        <input type="hidden" name="plan" value="">
                        <a-button v-if="value.is_hightlighted" size="large"
                            class="submit-button submit-essential">Let's Go</a-button>
                        <a-button v-else type="primary" size="large" ghost class="submit-button">Let's Go
                        </a-button>
                    </form>
                    <slot :name="`i_have_voucher__${name}`" />
                    <a v-if="!hasSlot(`i_have_voucher__${name}`)" class="btn-add-discount-code a-link"
                        @click="$emit('click-have-voucher', value)">I have a voucher</a>
                    <slot :name="`plan-title-list__${name}`" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 't-pricing-plan',
        props: {
            title: {
                type: String,
                default: `Choose your plan`
            },
            trial_status: {
                type: String,
                default: `You'll get a 7-day free trial`
            },
            most_popular_text: {
                type: String,
                default: 'Most Popular'
            },
            container: {
                type: Function
            },
            plans: {
                type: Object,
                default: () => {}
            }
        },
        data() {
            return {
                imagesCollapsed: false // If scroll not on top, collapse it
            }
        },
        computed: {
            validPlans() {
                return !(!this.plans || this.plans === {})
            },
            sortedPlans() {
                var plans = this.plans
                if (!this.validPlans) {
                    return {}
                }
                // var sortedPlans = {}
                // Object.keys(plans).sort((a, b) => plans[b].order_number - plans[a].order_number).forEach(key => {
                //     sortedPlans[key] = plans[key]
                // });
                return plans
            }
        },
        methods: {
            hasSlot(name) {
                return !!this.$slots[name]
            }
        }
    }
</script>

<style lang="scss">
    .pricing-plans {
        width: 1020px;
        margin: auto;
        &__header {
            margin-bottom: 40px;
        }
        &__list-plan {
            display: flex;
            width: 100%;
            .plan-wrap {
                flex: 1;
                border: 1px solid $line-color;
                margin: 0 8px;
                border-radius: 8px;
                max-width: 490px;
                overflow: hidden;
                &.plan-popular {
                    background-image: linear-gradient(to top, #923dff, #3d51ff);
                    color: $white-color;
                    position: relative;
                    .is-highlighted {
                        position: absolute;
                        width: 100%;
                        height: 40px;
                        background: #2118d0;
                        text-transform: uppercase;
                        font-weight: 600;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    .plan {
                        &-price {
                            &__month {
                                color: $white-color !important;
                            }
                        }
                    }
                    .submit-button {
                        background: $white-color !important;
                        &:hover {
                            background: $primary-color !important;
                        }
                    }
                }
                .plan {
                    text-align: center;
                    padding: 74px 24px 18px 24px;
                    &-price {
                        margin-bottom: 0 !important;
                        font-weight: $font-weight-semibold;
                        &__icon {
                            margin-right: 6px;
                            font-size: 20px !important;
                            position: relative;
                            top: -12px !important;
                        }
                        &__money {
                            font-size: 54px !important;
                        }
                        &__month {
                            font-weight: normal;
                            color: $text-color-secondary;
                            font-size: 18px !important;
                            visibility: hidden;
                            &.visible {
                                visibility: visible;
                            }
                        }
                    }
                    &-list-title {
                        
                    }
                    .submit-button {
                        width: 100%;
                        height: 48px;
                        border-radius: 4px;
                        margin-bottom: 38px;
                        &.here {
                            color: $text-color-secondary;
                            &:hover {
                                background: $white-color !important;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
